import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthStore } from './auth.store';

/**
 * Forces a user flagged with `mustChangePassword` to set a new password before
 * reaching any in-app route. Declared as `canActivateChild` on the app shell so
 * it covers every descendant (including lazy routes). The change-password page
 * itself lives under `/auth`, outside the shell, so it stays reachable.
 */
export const passwordChangeGuard: CanActivateChildFn = () => {
	const platformId = inject(PLATFORM_ID);
	const authStore = inject(AuthStore);
	const router = inject(Router);

	// Session state is only reliable on the client; defer on the server.
	if (!isPlatformBrowser(platformId)) return true;

	if (authStore.user()?.mustChangePassword) {
		return router.createUrlTree(['/auth/change-password']);
	}
	return true;
};
